import script from "./ResponsiveNavLink.vue?vue&type=script&setup=true&lang=js"
export * from "./ResponsiveNavLink.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__